import { IconButton } from '@material-ui/core'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import WarningDialog from 'components/modelManager/molecules/popups/WarningDialog'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'

interface IProps {
    isPristineForm: boolean
    backToRouteURL?: string
}

export const BackFromEditorButton = ({ isPristineForm, backToRouteURL }: IProps) => {
    const [isOpenedWarningPopup, setIsOpenedWarningPopup] = useState(false)
    const history = useHistory()

    const onClick = () => {
        if (isPristineForm) {
            if (backToRouteURL) {
                history.push(backToRouteURL)
            } else {
                history.goBack()
            }
        } else {
            setIsOpenedWarningPopup(true)
        }
    }

    const handleCloseWarning = () => {
        setIsOpenedWarningPopup(false)
    }

    const handleContinueWarning = () => {
        setIsOpenedWarningPopup(false)
        if (backToRouteURL) {
            history.push(backToRouteURL)
        } else {
            history.goBack()
        }
    }

    return (
        <>
            <div>
                <IconButton onClick={onClick} aria-label="back">
                    <ArrowBackIcon />
                </IconButton>
            </div>
            <WarningDialog
                open={isOpenedWarningPopup}
                handleClose={handleCloseWarning}
                handleContinue={handleContinueWarning}
                title="Warning"
                content="You have unsaved changes in the form. Are you sure you want to continue?"
            />
        </>
    )
}
